import { useEventListener, useLatest } from "../";

import { type BasicTarget, defaultWindow, getTargetElement } from "./helpers";

/**
 * @title useClickOutside
 */
export type UseClickOutside = (
  /**
   * dom element
   */
  target: BasicTarget<Element>,
  /**
   * listener fucntion
   */
  handler: (evt: EventType) => void,
  /**
   * whether the listener fucntion is enabled
   */
  enabled?: boolean
) => void;

export type EventType = MouseEvent | TouchEvent;

const listerOptions = {
  passive: true,
};

export const useClickOutside: UseClickOutside = (
  target: BasicTarget<Element>,
  handler: (evt: EventType) => void,
  enabled = true
): void => {
  const savedHandler = useLatest(handler);

  const listener = (event: EventType) => {
    if (!enabled) {
      return;
    }
    const element = getTargetElement(target);
    if (!element) {
      return;
    }

    const elements = event.composedPath();
    if (element === event.target || elements.includes(element)) {
      return;
    }

    savedHandler.current(event);
  };

  useEventListener("mousedown", listener, defaultWindow, listerOptions);
  useEventListener("touchstart", listener, defaultWindow, listerOptions);
};
